exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".followup-input {\n  display: flex;\n  margin: 2em 0; }\n  .followup-input input {\n    width: 100%;\n    border: 1px solid #16448e;\n    outline: none;\n    padding: 0.5em;\n    text-align: initial; }\n\n.followup-label {\n  width: 5em;\n  font-weight: bold;\n  color: #16448e;\n  margin: auto; }\n", ""]);

